import * as me from './me/reducer'
import * as ui from './ui/reducer'
import * as modals from './modals/reducer'

import * as news from './news/reducer'
import * as heroes from './heroes/reducer'
import voting from './voting/reducers'
import marketplace from './marketplace/reducers'
import lscSchedules from './lsc-schedules/reducers'
import lscTransportControl from './lsc-transportControl/reducers'
import emergencyAlert from './emergency-alert/reducers'


export default {
  me,
  ui,
  modals,

  news,
  heroes,
  voting,
  marketplace,
  lscSchedules,
  lscTransportControl,
  emergencyAlert,
}
